export default 'M24 12a2 2 0 0 1-2 2H2a2 2 0 1 1 0-4h20a2 2 0 0 1 2 2z';